// extracted by mini-css-extract-plugin
export default {"storyDetailAdvertAvatar":"c-r_hj","storyDetailAdvertAvatar__image":"c-r_hk"};